<template>
  <a-modal
    v-model="show"
    :centered="true"
    :keyboard="false"
    :footer="null"
    :width="750"
    @cancel="handleCancleClick"
    :title="$t('common.info')">
    <a-layout class="user-info">
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
              {{$t('device.companyName')}}：
            </div>
            <div class="col">
              {{deviceInfoData.companyName}}
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
            {{$t('device.deviceCode')}}：
            </div>
            <div class="col">
              {{deviceInfoData.deviceCode}}
            </div>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
            {{$t('device.sn')}}：
            </div>
            <div class="col">
              {{deviceInfoData.sn}}
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
            {{$t('common.status')}}：
            </div>
            <div class="col">
              <span v-if="deviceInfoData.isBinded === '1'">{{$t('device.binded')}}</span>
              <span v-else>{{$t('device.unbinded')}}</span>
            </div>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
              {{$t('device.online')}}：
            </div>
            <div class="col">
              <span v-if="deviceInfoData.isOnline == 'online'" class="ju_greed">{{$t('device.online')}}</span>
              <span v-else class="z_red">{{$t('device.offline')}}</span>
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
              {{$t('device.uiName')}}：
            </div>
            <div class="col">
              <span v-if="deviceInfoData.uiName != ''">
                {{deviceInfoData.uiName}}
              </span>
              <span v-else>{{$t('common.default')}}</span>
            </div>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
              {{$t('device.photoTime')}}：
            </div>
            <div class="col">
              {{deviceInfoData.photoTime}}
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
              {{$t('device.goodsNum')}}：
            </div>
            <div class="col">
              <span v-if="deviceInfoData.goodsNum == '0'">{{$t('common.default')}}</span>
              <span v-else>{{deviceInfoData.goodsNum}}</span>
            </div>
        </div>
      </div>

      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
            {{$t('device.intervalTime')}}：
          </div>
          <div class="col">
            {{deviceInfoData.intervalTime}}
          </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">

        </div>
      </div>


      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
              {{$t('device.address')}}：
            </div>
            <div class="col">
              {{deviceInfoData.address}}
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
              {{$t('device.orderCount')}}：
            </div>
            <div class="col">
              {{deviceInfoData.orderCount}}
            </div>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
              {{$t('device.lastestOnlineTime')}}：
            </div>
            <div class="col">
              {{deviceInfoData.lastestOnlineTime}}
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
              {{$t('device.macAddress')}}：
            </div>
            <div class="col">
              {{deviceInfoData.mac}}
            </div>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
              {{$t('device.resolution')}}：
            </div>
            <div class="col">
              {{deviceInfoData.pixed}}
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
              {{$t('device.deviceSN')}}：
            </div>
            <div class="col">
              {{deviceInfoData.sn}}
            </div>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
              {{$t('device.deviceVersion')}}：
            </div>
            <div class="col">
              {{deviceInfoData.appVersion}}
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
              {{$t('device.deviceKey')}}：
            </div>
            <div class="col">
              {{deviceInfoData.deviceKey}}
            </div>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
              {{$t('device.deviceName')}}：
            </div>
            <div class="col">
              {{deviceInfoData.deviceName}}
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
              {{$t('device.deviceIMEI')}}：
            </div>
            <div class="col">
              {{deviceInfoData.imei}}
            </div>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
            {{$t('device.activationCode')}}：
          </div>
          <div class="col">
            {{deviceInfoData.activeCode}}
          </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
            {{$t('device.leyaoyaoCode')}}：
          </div>
          <div class="col">
            {{deviceInfoData.leyaoyaoCode}}
          </div>
        </div>
      </div>

      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
              {{$t('device.filterNum')}}：
            </div>
            <div class="col">
              <span v-if="deviceInfoData.filterNum == '0'">{{$t('common.default')}}</span>
              <span v-else>{{deviceInfoData.filterNum}}</span>
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
           <div class=" z-col-auto ju_title3">
              {{$t('device.pagerNum')}}：
            </div>
            <div class="col">
              {{deviceInfoData.pagerNum}}
            </div>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
            {{$t('device.electronicPhoto')}}：
          </div>
          <div class="col">
            <span v-if="deviceInfoData.downloadType == '2'">{{$t('device.scanDownload')}}</span>
            <span v-else>{{$t('device.sendFriend')}}</span>
          </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">
              {{$t('device.vendorTerminalSn')}}：
            </div>
            <div class="col">
              {{deviceInfoData.vendorTerminalSn}}
            </div>
          </div>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
            {{ $t('device.isSupperCoins') }}：
          </div>
          <div class="col">
            <span v-if="deviceInfoData.isCoins == '0'">{{ $t('common.no') }}</span>
            <span v-else>{{ $t('common.yes') }}</span>
          </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">
              {{$t('device.vendorTerminalKey')}}：
            </div>
            <div class="col">
              {{deviceInfoData.vendorTerminalKey}}
            </div>
          </div>
        </div>

      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">
              {{ $t('device.showName') }}：
            </div>
            <div class="col">
              {{deviceInfoData.showName}}
            </div>
        </div>
        <div class="z-col-xs-6 z-row align-items-center justify-content-right">
          <div class=" z-col-auto ju_title3">
          {{$t('device.vendorTerminalUpdateTime')}}：
        </div>
          <div class="col">
            {{deviceInfoData.vendorTerminalUpdateTime}}
          </div>
        </div>
      </div>

      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-12">
          <div class="ju_title3">
            H5 URL：{{deviceInfoData.h5Url}}
          </div>
        </div>
      </div>

<!--备注不用展示-->
<!--      <div class="z-row align-items-center justify-content-left z_mb10">-->
<!--          <div class=" z-col-auto ju_title3">-->
<!--            {{ $t('device.remark') }}：-->
<!--          </div>-->
<!--          <div class="col">-->
<!--            {{deviceInfoData.remark}}-->
<!--          </div>-->
<!--      </div>-->

      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-3 z-row align-items-center justify-content-left">
          <a-form-item>
           <a-button type="primary"  @click="reset"  class="ju_mr20" >{{ $t('device.reset') }}</a-button>
           </a-form-item>
        </div>
        <!-- 新增重启APP按钮 -->
        <div class="z-col-xs-3 z-row align-items-center justify-content-left">
          <a-form-item>
            <a-button type="primary" @click="restartApp">{{ $t('device.restartApp') }}</a-button>
          </a-form-item>
        </div>
        <div class="z-col-xs-3 z-row align-items-center justify-content-left">
          <a-form-item>
           <a-button type="primary"  @click="showMenu">{{ $t('device.showMenu') }}</a-button>
           </a-form-item>
        </div>
        <div class="z-col-xs-3 z-row align-items-center justify-content-left">
          <a-form-item>
           <a-button type="primary"  @click="hideMenu">{{ $t('device.hideMenu') }}</a-button>
           </a-form-item>
        </div>
        <div class="z-col-xs-3 z-row align-items-center justify-content-left">
          <a-form-item>
            <a-button type="primary"  @click="reportLog">{{ $t('device.reportLog') }}</a-button>
          </a-form-item>
        </div>

        <div class="z-col-xs-3 z-row align-items-center justify-content-left">
          <a-form-item>
            <a-button type="primary"  @click="reflashUI">{{ $t('device.updateUI') }}</a-button>
          </a-form-item>
        </div>

        <div class="z-col-xs-3 z-row align-items-center justify-content-left" v-if="currentUser && currentUser.username === 'superAdmin'">
          <a-form-item>
            <a-button type="primary"  @click="appUpgrade">{{ $t('device.updateApp') }}</a-button>
          </a-form-item>
        </div>

        <div class="z-col-xs-3 z-row align-items-center justify-content-left" v-if="currentUser && currentUser.username === 'superAdmin'">
          <a-form-item>
            <a-button type="primary"  @click="customConfig">{{ $t('device.updateConfig') }}</a-button>
          </a-form-item>
        </div>
      </div>

      <!-- Shell 命令执行区域（仅超级管理员可见） -->
      <template v-if="currentUser && currentUser.username === 'superAdmin'">
      <a-divider>{{ $t('device.shellExec') }}</a-divider>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-12">
          <a-form-item :label="$t('device.shellCommand')">
            <a-textarea
              v-model="shellCommand"
              :rows="3"
              :placeholder="$t('device.shellCommandPlaceholder')"
              maxlength="500"
              show-word-limit
            />
          </a-form-item>
        </div>
      </div>
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-12">
          <a-button
            type="primary"
            @click="sendShellCommand"
            :loading="sendingShellCommand"
            icon="terminal">
            {{ $t('device.sendShellCommand') }}
          </a-button>
          <span style="margin-left: 8px; color: #999; font-size: 12px;">
            {{ $t('device.dangerousConfirmTip') }}
          </span>
        </div>
      </div>
      </template>

      <!-- PC机信息（不为空时展示） -->
      <template v-if="pcInfoObj">
        <a-divider>{{ $t('device.pcInfo') }}</a-divider>
        <div class="z-row align-items-center justify-content-left z_mb10">
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcName') }}：</div>
            <div class="col">{{ pcInfoObj.pcName || '-' }}</div>
          </div>
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcOs') }}：</div>
            <div class="col">{{ pcInfoObj.os || '-' }}</div>
          </div>
        </div>
        <div class="z-row align-items-center justify-content-left z_mb10">
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcIp') }}：</div>
            <div class="col">{{ pcInfoObj.ip || '-' }}</div>
          </div>
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcMac') }}：</div>
            <div class="col">{{ pcInfoObj.mac || '-' }}</div>
          </div>
        </div>
        <div class="z-row align-items-center justify-content-left z_mb10">
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcCpu') }}：</div>
            <div class="col">{{ pcInfoObj.cpuName || '-' }}</div>
          </div>
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcCpuUsage') }}：</div>
            <div class="col">{{ pcInfoObj.cpuUsage != null ? pcInfoObj.cpuUsage + '%' : '-' }}</div>
          </div>
        </div>
        <div class="z-row align-items-center justify-content-left z_mb10">
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcMemory') }}：</div>
            <div class="col">{{ pcInfoObj.memoryTotal != null ? (pcInfoObj.memoryUsed + ' / ' + pcInfoObj.memoryTotal + ' GB') : '-' }}</div>
          </div>
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcMemoryUsage') }}：</div>
            <div class="col">{{ pcInfoObj.memoryUsage != null ? pcInfoObj.memoryUsage + '%' : '-' }}</div>
          </div>
        </div>
        <div class="z-row align-items-center justify-content-left z_mb10">
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcTemperature') }}：</div>
            <div class="col">{{ pcInfoObj.temperature != null ? pcInfoObj.temperature + ' °C' : '-' }}</div>
          </div>
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcDisk') }}：</div>
            <div class="col">{{ pcInfoObj.diskTotal != null ? (pcInfoObj.diskFree + ' / ' + pcInfoObj.diskTotal + ' GB') : '-' }}</div>
          </div>
        </div>
        <div class="z-row align-items-center justify-content-left z_mb10">
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcDefaultPrinter') }}：</div>
            <div class="col">{{ pcInfoObj.defaultPrinter || $t('device.pcNoPrinter') }}</div>
          </div>
          <div class="z-col-xs-6 z-row align-items-center justify-content-left">
            <div class=" z-col-auto ju_title3">{{ $t('device.pcReportTime') }}：</div>
            <div class="col">{{ pcInfoObj.reportTime || '-' }}</div>
          </div>
        </div>
      </template>

    </a-layout>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name:'DeviceInfo',
  props:{
     deviceInfoVisiable: {
      require: true,
      default: false
    },
    deviceInfoData: {
      require: true
    },
  },
  computed:{
    ...mapState({
      currentUser: state => state.account.user
    }),
  show: {
        get: function () {
          return this.deviceInfoVisiable
        },
        set: function () {
        }
      },
    // PC机信息(JSON字符串)解析对象，为空时返回 null 不展示
    pcInfoObj() {
      const raw = this.deviceInfoData && this.deviceInfoData.pcInfo
      if (!raw) return null
      try {
        return typeof raw === 'string' ? JSON.parse(raw) : raw
      } catch (e) {
        return null
      }
    },
  },
  data() {
    return {
      shellCommand: '', // Shell 命令输入
      sendingShellCommand: false // 发送 Shell 命令加载状态
    }
  },
  methods:{
    reportLog() {
      this.$post(`amqp/createDeviceLog/${this.deviceInfoData.deviceCode}`).then((r) => {
        if(r.data.code =='200'){
          this.$message.success(this.$t('device.command'));
        }
        this.fetch()
      }).catch(() => {
      })
    },
    handleCancleClick () {
      this.$emit('close')
    },
    reset() {
    this.$post(`amqp/control/${this.deviceInfoData.deviceCode}`, {reset: "1",switchMenu: "0"}).then((r) => {
          console.log(r)
          if(r.data.code =='200'){
            this.$message.success(this.$t('device.command'));
          }
          this.$emit('success')
          this.fetch()
        }).catch(() => {

        })
  },
    restartApp() {
      this.$post(`amqp/control/${this.deviceInfoData.deviceCode}`, {reset: "2",switchMenu: "0"}).then((r) => {
        console.log(r)
        if(r.data.code =='200'){
          this.$message.success(this.$t('device.command'));
        }
        this.$emit('success')
        this.fetch()
      }).catch(() => {

      })
    },
  showMenu(){
    this.$post(`amqp/control/${this.deviceInfoData.deviceCode}`, {reset: "0",switchMenu: "1"}).then((r) => {
          console.log(r)
          if(r.data.code =='200'){
            this.$message.success(this.$t('device.command'));
          }
          this.$emit('success')
          this.fetch()
        }).catch(() => {

        })
  },
  hideMenu(){
    this.$post(`amqp/control/${this.deviceInfoData.deviceCode}`, {reset: "0",switchMenu: "0"}).then((r) => {
          console.log(r)
          if(r.data.code =='200'){
            this.$message.success(this.$t('device.command'));
          }
          this.$emit('success')
          this.fetch()
        }).catch(() => {

        })
  },
    reflashUI(){
      this.$post(`amqp/ui/${this.deviceInfoData.deviceCode}`, {reflashUI: "1"}).then((r) => {
          console.log(r)
          if(r.data.code =='200'){
            this.$message.success(this.$t('device.notifiedUpdateUI'));
          }
          this.$emit('success')
          this.fetch()
        }).catch(() => {

        })
    },
    appUpgrade(){
      this.$post(`amqp/app/${this.deviceInfoData.deviceCode}`, {appUpgrade: "1"}).then((r) => {
        console.log(r)
        if(r.data.code =='200'){
          this.$message.success(this.$t('device.notifiedUpdateApp'));
        }
        this.$emit('success')
        this.fetch()
      }).catch(() => {

      })
    },
    customConfig(){
      this.$post(`amqp/config/${this.deviceInfoData.deviceCode}`, {customConfig: "1"}).then((r) => {
        console.log(r)
        if(r.data.code =='200'){
          this.$message.success(this.$t('device.notifiedUpdateConfig'));
        }
        this.$emit('success')
        this.fetch()
      }).catch(() => {

      })
    },
    // 检测是否为危险命令
    isDangerousCommand(cmd) {
      const dangerousPatterns = [
        /\brm\s+-rf\b/,           // rm -rf
        /\bmkfs\b/,               // 格式化文件系统
        /\bdd\s+if=/,             // dd 写入
        /\bsudo\s+reboot\b/,      // 重启
        /\bchmod\s+777\b/,        // 修改权限
        /\bshutdown\b/,           // 关机
        /\binit\s+0\b/,           // 关机
        /\bfactory-reset\b/       // 恢复出厂设置
      ];
      return dangerousPatterns.some(pattern => pattern.test(cmd));
    },
    // 发送 Shell 命令
    sendShellCommand() {
      // 验证输入
      if (!this.shellCommand || !this.shellCommand.trim()) {
        this.$message.warning(this.$t('device.inputShellCommand'));
        return;
      }

      const cmd = this.shellCommand.trim();

      // 危险命令二次确认
      if (this.isDangerousCommand(cmd)) {
        this.$confirm({
          title: this.$t('device.dangerousWarningTitle'),
          content: this.$t('device.dangerousWarningContent'),
          okText: this.$t('device.confirmExecute'),
          cancelText: this.$t('common.cancel'),
          centered: true,
          onOk: () => {
            this.executeShellCommand(cmd);
          }
        });
      } else {
        this.executeShellCommand(cmd);
      }
    },
    // 执行 Shell 命令
    executeShellCommand(cmd) {
      this.sendingShellCommand = true;
      this.$post(`amqp/shellCmd/${this.deviceInfoData.deviceCode}`, {
        shellCmd: cmd
      }).then((r) => {
        if (r.data && r.data.code === 200) {
          this.$message.success(this.$t('device.commandSent'));
          this.shellCommand = ''; // 清空输入框
        } else {
          this.$message.error((r.data && r.data.message) || this.$t('device.sendFailed'));
        }
      }).catch((error) => {
        console.error('发送 Shell 命令失败:', error);
        this.$message.error(error.message || this.$t('device.networkError'));
      }).finally(() => {
        this.sendingShellCommand = false;
      });
    }
  }
}
</script>
<style lang="less" scoped>
@import "devicInfo";
</style>



// WEBPACK FOOTER //
// src/views/device/DeviceInfo.vue